module.exports = window['ko'];